<esos-page-heading size="xl">Terms And Conditions</esos-page-heading>
<ng-container *ngIf="terms$ | async as terms">
  <p class="govuk-body">
    Below are the Terms and Conditions (Terms) associated with the use of the Manage your UK Emissions Trading Scheme
    reporting service (METS).
  </p>
  <p class="govuk-body">You must accept these Terms in order to complete the registration of your account.</p>
  <p class="govuk-body">METS has been established for the purpose of:</p>
  <ul class="govuk-list govuk-list--bullet">
    <li>
      facilitating the electronic submission of certain applications, information, and reports by Operators, Aircraft
      Operators and Verifiers under the UK Emissions Trading Scheme (UK ETS)
    </li>
    <li>
      facilitating the electronic submission of certain applications, information, and reports by Northern Ireland
      Electricity Generation Operators and Verifiers under the EU Emissions Trading System (EU ETS) under the terms of
      the Windsor Framework
    </li>
    <li>
      facilitating communication between Regulators, Aircraft Operators, Operators, and Verifiers under the UK ETS and
      EU ETS
    </li>
    <li>
      facilitating the electronic submission of applications, information, and reports by Aeroplane Operators and their
      Verifiers under the Carbon Offsetting and Reduction Scheme for International Aviation (CORSIA)
    </li>
    <li>facilitating communication between Regulators, Aeroplane Operators and Verifiers under the CORSIA</li>
  </ul>
  <p class="govuk-body">
    Any information submitted through METS will be transmitted electronically to the appropriate Regulator for the
    person making the submission.
  </p>

  <h3 class="govuk-heading-m">1. Legal Notices</h3>
  <p class="govuk-body">1.1 Definitions</p>
  <p class="govuk-body">
    "Aeroplane Operator" includes an Aeroplane Operator as defined in the CORSIA Order, and any person that has
    previously been a CORSIA Aircraft Operator under the CORSIA Order.
  </p>
  <p class="govuk-body">
    "Aircraft Operator" includes an Aircraft Operator as defined in the UK ETS Order, and any person that has previously
    been a UK ETS Aircraft Operator under the UK ETS.
  </p>
  <p class="govuk-body">
    "Regulator" is the regulator as identified in the UK ETS Order, EU ETS Regulations or the CORSIA Order, as
    appropriate.
  </p>
  <p class="govuk-body">
    "CORSIA Order" is the Air Navigation (Carbon Offsetting and Reduction Scheme for International Aviation) Order 2021,
    as amended from time to time.
  </p>
  <p class="govuk-body">
    "EU ETS Regulations" means the Greenhouse Gas Emissions Trading Scheme Regulations 2012, as amended from time to
    time.
  </p>
  <p class="govuk-body">
    "Malicious Software" means any software program or code intended to destroy, interfere with, corrupt, or cause
    undesired effects on program files, data or other information, executable code or application software macros,
    whether or not its operation is immediate or delayed, and whether the malicious software is introduced wilfully,
    negligently or without knowledge of its existence.
  </p>
  <p class="govuk-body">"METS" means the Manage your UK Emissions Trading Scheme reporting service.</p>
  <p class="govuk-body">
    "Operator", in relation to an installation, has the meaning given in the UK ETS Order or in the EU ETS Regulations,
    as appropriate.
  </p>
  <p class="govuk-body">"Terms" means the Terms and Conditions of METS.</p>
  <p class="govuk-body">
    "The Windsor Framework" is the Protocol on Ireland/Northern Ireland to the Withdrawal Agreement, as amended by Joint
    Committee Decision No 1/2023.
  </p>
  <p class="govuk-body">
    "UK ETS Order" means the Greenhouse Gas Emissions Trading Scheme Order 2020, as amended from time to time.
  </p>
  <p class="govuk-body">
    "Us" "Our" means the Secretary of State, the Welsh Ministers, the Scottish Ministers and the Department of
    Agriculture, Environment and Rural Affairs in Northern Ireland.
  </p>
  <p class="govuk-body">
    "Verifier" has the meaning given in the UK ETS Order, EU ETS Regulations or the CORSIA Order, as appropriate.
  </p>
  <p class="govuk-body">
    "You" "Your" means Aircraft Operator, Operator, Aeroplane Operator or and Verifier, and Your representative
    ("Representative") and visitors to METS where the context provides.
  </p>

  <h4 class="govuk-heading-s">Status of Terms</h4>
  <p class="govuk-body">1.2.1 These Terms govern access to and use of METS.</p>
  <p class="govuk-body">
    1.2.2 If You are an Aircraft Operator, Operator, Aeroplane Operator or Verifier, by clicking on the "Accept" button
    in METS You are indicating that You agree to be bound by these Terms.
  </p>
  <p class="govuk-body">
    1.2.3 If You are a visitor to METS, by continuing to use any part of METS You are accepting the latest version of
    these Terms in full. If You object to any of these Terms You should not use METS and should leave it immediately.
  </p>

  <h4 class="govuk-heading-s">Modifications</h4>
  <p class="govuk-body">
    1.3 We may revise these Terms at any time, so You should check METS regularly to ensure that You are aware of the
    latest version of these Terms.
  </p>
  <p class="govuk-body">
    1.4 METS is subject to change without notice at any time. We reserve the right at Our sole discretion to make any
    alteration, correction or improvement (including adding functionality) to or to withdraw or correct any error or
    omission in any portion of METS without notice.
  </p>
  <p class="govuk-body">
    1.5 These Terms apply to the whole of METS including both the non-secure area, which may be accessed by any member
    of the public as a visitor, and the secure areas, which may only be accessed and used by those Aircraft Operators,
    Operators, Aeroplane Operators and their appointed Verifiers or their authorised representatives ("Representatives")
    having the specific access rights granted by Us, using authorised usernames and passwords.
  </p>

  <h3 class="govuk-heading-m">2. Access to Secure Areas</h3>
  <p class="govuk-body">2.1 Your Representatives</p>
  <p class="govuk-body">2.1.1 You are responsible for ensuring that your Representatives comply with these Terms.</p>
  <p class="govuk-body">
    2.1.2 Representatives nominated by You are acting as Your agent and You are bound by and responsible as principal
    for their acts and omissions in relation to METS, whether or not the act or omission is outside the authority
    (express or implied) of Your Representatives.
  </p>
  <p class="govuk-body">
    2.1.3 A Regulator is entitled to assume, without any duty to enquire or investigate further, that any requests,
    submission of information, or other communication are authentic and validly made on Your behalf and with Your full
    knowledge and authority where made using a valid username and password. You have full responsibility for all such
    requests, submission of information or other communications.
  </p>
  <p class="govuk-body">
    2.1.4 You must inform Us immediately if any Representative ceases to be authorised by You. As soon as practicable
    thereafter We shall then deactivate the relevant username.
  </p>
  <p class="govuk-body">2.2 Limited access and security</p>
  <p class="govuk-body">
    2.2.1 Except in sub-Clause 2.2.5, in this sub-Clause 2.2 "You" includes Your Representatives.
  </p>
  <p class="govuk-body">
    2.2.2 Your rights to access the secure areas of METS are limited to the level of access You have been granted. You
    must not access or attempt to access any part of METS to which You do not have express rights of access.
  </p>
  <p class="govuk-body">
    2.2.3 From time to time You may be issued with or asked to provide a username and password. You must use the
    password only for access to those applicable secure areas of METS and not for any other purpose.
  </p>
  <p class="govuk-body">
    2.2.4 You must keep Your password confidential at all times, and must not disclose the password or permit anyone
    else to use Your password or username.
  </p>
  <p class="govuk-body">
    2.2.5 You are responsible for ensuring the security and integrity of the computer used by You to access the secure
    areas of METS ("Your computer"). Without prejudice to this and without limitation to Your responsibilities, You
    must:
  </p>
  <p class="govuk-body">
    (a) have good quality, commercially available and supported anti-virus software, (which includes protection against
    Malicious Software by checking, blocking from entry to, deleting from, quarantining or otherwise rendering it
    ineffective) installed and running on Your computer along with a firewall preventing unauthorised access to Your
    machine and that You apply the latest updates as they become available;
  </p>
  <p class="govuk-body">
    (b) every time You seek to access the secure area of METS ensure that You are entering Your username and password
    into the correct website;
  </p>
  <p class="govuk-body">
    (c) follow general good practice guidelines for accessing and using the internet safely, including as a minimum,
    complying with any security directions and procedures notified to You by Us.
  </p>
  <p class="govuk-body">
    2.2.6 You are responsible for the consequences, including financial consequences, of any failure by You and Your
    Representatives to comply with Your obligations under these Terms, including Clauses 2.2.4 and 2.2.5. Any breach of
    any of these Terms by anyone to whom You or Your Representatives disclose the password will be treated as if the
    breach had been committed by You, and will not relieve You of Your obligations under these Terms.
  </p>
  <p class="govuk-body">
    2.2.7 You must notify Us immediately upon becoming aware of any unauthorised use of a username or password,
    disclosure of a password, or any other breach of security.
  </p>
  <p class="govuk-body">
    2.2.8 In the event of any failure or error in the operation of a password, You shall cease using the password, exit
    METS immediately, and notify Us of such failure or error.
  </p>
  <p class="govuk-body">
    2.2.9 You shall cease to use and delete Your password from any of Your records upon expiry or termination of Your
    right to use METS.
  </p>
  <p class="govuk-body">
    2.2.10 We reserve the right to change Your password and username at any time in our sole discretion.
  </p>
  <p class="govuk-body">
    2.2.11 You may change Your username and password issued by Us. You agree to notify Us promptly of any changes to
    Your username, and that any password must meet Our security requirements.
  </p>
  <p class="govuk-body">
    2.2.12 You must exit the secure area by logging out in accordance with the instructions in METS at the end of each
    session.
  </p>

  <h3 class="govuk-heading-m">3. Use of METS</h3>
  <p class="govuk-body">3.1 In this clause, You includes Your Representatives.</p>
  <p class="govuk-body">3.2.1 What You may do</p>
  <p class="govuk-body">The secure parts of METS may only be used:</p>
  <p class="govuk-body">
    (a) by Aircraft Operators, Operators, Aeroplane Operators, Verifiers and Representatives who have been granted
    access rights by Us;
  </p>
  <p class="govuk-body">
    (b) for the purpose of submitting information to a Regulator or Verifier as required by the UK ETS Order or EU ETS
    Regulations or the CORSIA Order and communicating with a Regulator or Verifier.
  </p>
  <p class="govuk-body">3.2.2 METS may only be used:</p>
  <p class="govuk-body">(c) in accordance with these Terms and for lawful purposes.</p>
  <p class="govuk-body">3.3 What You may not do</p>
  <p class="govuk-body">You will not:</p>
  <p class="govuk-body">
    (a) to the maximum extent permitted by law, reverse engineer, translate, adapt or modify any software used in
    connection with any part of METS;
  </p>
  <p class="govuk-body">
    (b) damage or attempt to damage or corrupt (including the introduction of any Malicious Software) any software or
    data used in connection with any part of METS, nor, attempt to gain unauthorised access to the secure part of METS,
    the server on which METS is stored or any server, computer or database connected to METS, or engage in any other
    behaviour that may reasonably be expected to inhibit others from using METS;
  </p>
  <p class="govuk-body">
    (c) create any links from any other website to METS without Our express prior written permission; or
  </p>
  <p class="govuk-body">
    (d) use METS in a manner that infringe the rights of any Regulator or any third party, or restrict or inhibit the
    use and enjoyment of METS by any third party or in breach of law.
  </p>

  <h3 class="govuk-heading-m">4. Third party sites and hyperlinking</h3>
  <p class="govuk-body">
    We may link METS to other websites, which are not under the control of, or maintained by Us. We are providing these
    links to You only as a matter of convenience and, to the maximum extent permitted by law, We shall not be
    responsible for the content, availability or reliability of such websites. The inclusion of hyperlinks to such
    websites does not imply any endorsement of views, statements or information contained in such websites. We do not
    endorse or recommend any products, materials or services displayed or offered on any websites which may be linked to
    METS.
  </p>

  <h3 class="govuk-heading-m">5. Disclaimers</h3>
  <p class="govuk-body">
    5.1 We do not represent or make any warranty in respect of the accuracy, reliability, completeness, currency or
    continuous supply of any of the content contained in or distributed through, or linked, downloaded or accessed from
    METS or the results obtained from using the content of METS.
  </p>
  <p class="govuk-body">
    5.2 We expressly disclaim any and all warranties, express or implied, to the extent permitted by any applicable law,
    including without limitation warranties of satisfactory quality, merchantability and fitness for purpose, with
    respect to METS and its content.
  </p>
  <p class="govuk-body">
    5.3 We do not warrant that METS or its content will be free from errors or that METS and the related server are free
    from computer viruses or other harmful applications.
  </p>
  <p class="govuk-body">
    5.4 We do not endorse or recommend any products, materials or services displayed or offered in METS, including
    Verifiers. The choice of, suitability of and the terms of appointment of a Verifier are matters solely between an
    Aircraft Operator, Aeroplane Operator or Operator and the relevant Verifier.
  </p>

  <h3 class="govuk-heading-m">6. Liability</h3>
  <p class="govuk-body">
    6.1 To the full extent permitted by any applicable laws, We accept no liability for any claims, loss, demands or
    damages of any kind with respect to METS or its content, which You or Your Representatives may suffer or incur
    arising from or in connection with METS or its content, including, without limitation, direct, indirect, or
    incidental loss or damages, loss of profits, loss of revenue, loss of data, loss of use or otherwise arising out of
    Your use of METS and whether or not the possibility of such loss has been notified to Us, including, but not limited
    to
  </p>
  <p class="govuk-body">(a) the introduction to METS of any Malicious Software;</p>
  <p class="govuk-body">
    (b) any attempt to gain unauthorised access to secure areas of METS, the server on which METS is stored or any
    server, computer or database connected to METS;
  </p>
  <p class="govuk-body">
    (c) any attack to METS via a denial-of-service attack or a distributed denial-of-service attack;
  </p>
  <p class="govuk-body">
    (d) any matter over which We have no control, including, but not limited to, the acts of third parties or unplanned
    outages;
  </p>
  <p class="govuk-body">(e) Your failure or that of Your Representatives to comply with these Terms; or</p>
  <p class="govuk-body">
    (f) the content of any material posted to METS by You or third parties which is defamatory, obscene, inaccurate,
    misleading, unlawful, pornographic or which in any way infringes a third party’s rights, including but not limited
    to, intellectual property rights.
  </p>

  <p class="govuk-body">
    6.2 Clause 6.1 will apply whether such claims, loss or damages arise in tort, contract, negligence or otherwise.
  </p>
  <p class="govuk-body">
    6.3 Nothing in these Terms shall exclude or limit Our liability for fraud, death or personal injury caused by
    negligence or any liability which cannot be excluded or limited under applicable law.
  </p>

  <h3 class="govuk-heading-m">7. Intellectual Property Rights</h3>
  <p class="govuk-body">
    7.1 You agree that all intellectual property rights in the data, text, images, materials and information in METS
    ("Content") and in the layout of METS are owned by Us (or Our licensors or any Regulator).
  </p>
  <p class="govuk-body">
    7.2 You will not alter or remove any copyright, trade mark or other proprietary mark, logo or notice of a Regulator
    or of any other organisation or public authority appearing anywhere in METS.
  </p>
  <p class="govuk-body">
    7.3 In relation only to the parts of METS to which You have access rights We grant You the right to view, download
    or print the Content for Your own private use or for use internally within Your business or for the purpose set out
    in clause 7.4.
  </p>
  <p class="govuk-body">
    7.4 Subject to clause 7.3, You may give copies of the Content referred to in clause 7.3 to others provided that: You
    make no charge; You in no way modify or edit the Content; and You attach a copy of this Clause and instruct the
    recipient to comply with it. Whenever possible and appropriate any authorised copying shall acknowledge Our
    ownership of the Content. One way of doing this is by adding the words e.g. "Copyright Environment Agency" to the
    information or copy.
  </p>
  <p class="govuk-body">
    7.5 You agree that You will not use the Content in any way other than as set out above (including without limitation
    use for commercial gain, for example by way of rental, licence, sale or providing services for consideration).
  </p>
  <p class="govuk-body">
    7.6 Your access to or use of METS and any materials available on it shall not be construed as granting to You any
    licence or assignment of any intellectual property rights in METS or such materials, other than the rights expressly
    granted in this Clause.
  </p>
  <p class="govuk-body">
    7.7 You will inform Us promptly if You become aware of any infringement or potential infringement of any of the
    intellectual property rights referred to in Clause 7.1.
  </p>

  <h3 class="govuk-heading-m">8. Confidentiality</h3>
  <p class="govuk-body">
    We will not disclose or publish any information provided to Us except as permitted under the UK ETS Order or EU ETS
    Regulations or the CORSIA Order, or as required by law (including but not limited to the Freedom of Information Act
    2000 or Environment Information Regulations 2004, the Freedom of Information (Scotland) Act 2002 and the
    Environmental Information (Scotland) Regulations 2004, as applicable.).
  </p>

  <h3 class="govuk-heading-m">9. Suspension and Termination of Access to METS</h3>
  <p class="govuk-body">
    9.1 We may suspend the operation of METS at any time for any reason which may include for repair or maintenance work
    or in order to update or upgrade the contents or functionality of METS from time to time. Access to or use of METS
    or sites linked to METS will not necessarily be uninterrupted or error free.
  </p>
  <p class="govuk-body">
    9.2 We may suspend or terminate Your and/or any Representatives access to METS immediately at any time without
    notice in the event that we reasonably believe that You and/or any Representatives have breached any of these Terms
    or might do so, or where We are required or authorised by law to do so.
  </p>
  <p class="govuk-body">9.3 Clauses 2.2.6, 5, 6, 7, 8, 9, and 11 shall survive termination.</p>

  <h3 class="govuk-heading-m">10. General</h3>
  <p class="govuk-body">
    10.1 These Terms shall be governed by and construed in accordance with the laws of England. You and We shall take
    reasonable steps to resolves any differences between us regarding these Terms, however, if we are unable to do so,
    any dispute or legal proceedings in relation to METS shall be brought in the courts of England and Wales.
  </p>
  <p class="govuk-body">
    10.2 The language of these Terms is English. If these terms are for any reason translated into any language other
    than English, the English text shall prevail.
  </p>
  <p class="govuk-body">
    10.3 If any provision or part of a provision of these Terms is held by a court of competent jurisdiction to be
    unenforceable, all other provisions shall remain in full force and effect.
  </p>
  <p class="govuk-body">
    10.4 These Terms comprise the entire agreement between You and Us in relation to Your access to and use of METS. To
    the extent that there is any conflict or discrepancy between the UK ETS Order or the EU ETS Regulations or the
    CORSIA Order (as applicable), and these Terms, the UK ETS Order or the EU ETS Regulations or the CORSIA Order (as
    applicable) shall prevail.
  </p>
  <p class="govuk-body">
    10.5 Nothing in these Terms shall prejudice or affect a Regulator’s exercise of its functions, duties and powers
    conferred, arising or imposed under the UK ETS Order, the EU ETS Regulations, the CORSIA Order, the Environment Act
    1995, or any other legislative provision, enactment, byelaw or regulation whatsoever.
  </p>
  <p class="govuk-body">
    10.6 Nothing in these Terms shall operate as a statutory approval, consent or licence from a Regulator.
  </p>
  <p class="govuk-body">10.7 No third parties have any rights under the Contract (Rights of Third Parties) Act 1999.</p>
  <p class="govuk-body">
    10.8 In these Terms, unless the context otherwise requires the words "other", "include" and "including" do not
    denote limitation in any way and the singular includes the plural and vice versa.
  </p>
  <p class="govuk-body">
    10.9 You may not transfer or in any other way make over to any third party the benefit of these Terms either in
    whole or in part.
  </p>
</ng-container>

<form (ngSubmit)="submitTerms()" [formGroup]="form">
  <div formControlName="terms" govuk-checkboxes>
    <ng-container govukLegend>
      <span class="govuk-visually-hidden">Accept terms and conditions</span>
    </ng-container>
    <govuk-checkbox [value]="true" label="I have read, understood and accept the terms and conditions"></govuk-checkbox>
  </div>
  <button esosPendingButton govukButton type="submit">Accept and continue</button>
</form>
